import React from 'react';
import styled from 'styled-components';

import { gray, green } from 'utils/style/colors';
import { convertDigitToProperFormat } from 'utils/number';

import Icon from 'components/Icon';
import { IOption } from 'components/Select/Select';

interface IComponentProps {
  chip: IOption;
  selected: boolean;
  onRemoveChip?: (chip: IOption) => void;
}

interface IChipProps {
  selected: boolean;
}

export const ChipContainer = styled('span')<IChipProps>`
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 2rem;
  padding: 0 0.5rem;
  border-radius: 10px;
  color: ${(props) =>
    props.selected ? 'var(--exact-white)' : 'rgba(0,0,0,0.6)'};
  background-color: ${(props) => (props.selected ? green : `${gray}`)};
  margin: 3px;
`;

export const RemoveIcon = styled(Icon)`
  cursor: pointer;
  float: left;
  font-size: 0.8rem !important;
  line-height: 2rem !important;
  padding-right: 0.5rem;
`;

class Chip extends React.Component<IComponentProps> {
  shouldComponentUpdate(nextProps: IComponentProps) {
    if (
      this.props.chip.value === nextProps.chip.value &&
      this.props.selected === nextProps.selected &&
      this.props.onRemoveChip === nextProps.onRemoveChip
    ) {
      return false;
    }
    return true;
  }

  handleRemoveChip = (chip: IOption) => () => {
    if (this.props.onRemoveChip) {
      this.props.onRemoveChip(chip);
    }
  };

  render() {
    const { chip, selected, onRemoveChip } = this.props;
    return (
      <ChipContainer key={chip.value} selected={selected}>
        {convertDigitToProperFormat(chip.label)}
        {onRemoveChip && (
          <RemoveIcon
            role="button"
            onClick={this.handleRemoveChip(chip)}
            type="x"
          />
        )}
      </ChipContainer>
    );
  }
}

export default React.memo(Chip);
